import strings from './strings'

export default {

    email() {
        return [
            { type: 'email', message: `ایمیل معتبر نیست` }
        ]
    },
    farsi(label) {
        return [
            {
                validator(rule, value, callback) {
                    if (!strings.isFarsi(value)) {
                        callback(`${label} باید فارسی باشد`)
                    }
                    callback()
                }
            }
        ]
    },
    mobile() {
        return [
            {
                validator(rule, value, callback) {
                    if (!strings.isMobile(value)) {
                        callback(`شماره موبایل معتبر نیست`)
                    }
                    callback()
                }
            }
        ]
    },
}
export const schemaValidator = async (_, value) => {
    if (!value || !value.trim()) {
        return Promise.resolve();
    }

    try {
        // Block dangerous HTML/Script patterns (but allow ld+json script tags handled above)
        const dangerousPatterns =
            /<script|<\/script>|<iframe|<\/iframe>|<object|<\/object>|<embed|<\/embed>|javascript:|onload=|onclick=/i;

        if (dangerousPatterns.test(value)) {
            throw new Error("ورود کدهای HTML یا Script مجاز نیست");
        }

        const parsed = JSON.parse(value);

        const schemas = Array.isArray(parsed)
            ? parsed
            : [parsed];

        const isValid = schemas.every(
            (item) =>
                item &&
                typeof item === "object" &&
                item["@context"] === "https://schema.org"
        );

        if (!isValid) {
            throw new Error(
                'تمام اسکیماها باید شامل "@context": "https://schema.org" باشند'
            );
        }

        return Promise.resolve();
    } catch (error) {
        return Promise.reject(new Error("فرمت JSON اسکیما معتبر نیست"));
    }
};